import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-furniture-fabrics-colors',
  templateUrl: './furniture-fabrics-colors.component.html',
  styleUrls: ['./furniture-fabrics-colors.component.css']
})
export class FurnitureFabricsColorsComponent implements OnInit {
    furnitureFabricsId;

    public setting?: Setting;

    public itemsListColours: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.furnitureFabricsId = this.stateService.getStateParams()['furniturefabrics_id'];
    }

    private async loadSetting() {
        if (!!this.furnitureFabricsId) {
            this.setting = (await this.datatask.Post(2118, { furniturefabrics_id: this.furnitureFabricsId }))[0];
        }
    }

    private async loadFurnitureFabricsColors(): Promise<void> {
        if (!!this.setting) {
            this.itemsListColours = await this.datatask.Post(2119, { furniturefabrics_id: this.setting.furniturefabrics_id });
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'furniturefabricscolor':
                this.stateService?.go('furniturefabricscolor', {
                    furniturefabrics_id: this.setting?.furniturefabrics_id,
                    furniturefabricscolor_id: '+'
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadFurnitureFabricsColors();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    furniturefabrics_id: string;
    page_heading: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('furnitureFabricsColors', {
//        templateUrl: 'views/components/views/furnitureFabricsColors/furnitureFabricsColors.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'furnitureFabricsColorsService', function ($stateParams, stateService, utilityService, furnitureFabricsColorsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let furnitureFabricsId = $stateParams.furniturefabrics_id

//            vm.model = {
//                setting: {},
//                itemsListColours: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await furnitureFabricsColorsService.getSetting({ furniturefabrics_id: furnitureFabricsId }))[0];

//                loadFurnitureFabricsColors();
//            }

//            async function loadFurnitureFabricsColors() {
//                if (utilityService.validateParmsValue(vm.model.setting.furniturefabrics_id) !== true) return;

//                vm.model.itemsListColours = [];

//                vm.model.itemsListColours = (await furnitureFabricsColorsService.listFurnitureFabricsColors({ furniturefabrics_id: vm.model.setting.furniturefabrics_id }));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'furniturefabricscolor':
//                        go({
//                            furniturefabrics_id: vm.model.setting.furniturefabrics_id,
//                            furniturefabricscolor_id: '+'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
